import { modifyState } from '~src/state';
import { handleTabQuotes } from './handleTabQuotes';

export const onChangeQuotesCategoryValue = async (event) => {
  modifyState('sidebarCurrentQuotesCategory', event.params.data.id);
  await handleTabQuotes();
};
